import { api } from './api';

const getCardBalanceList = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `BalanceTransfers/getCardBalanceList`,
        method: 'GET',
        params: {
            Page: pageNumber,
            PageSize: pageSize,
            ...data,
        },
    });
    return response.data;
};

const addBalanceTransfers = async (data) => {
    const response = await api({
        url: `BalanceTransfers/add`,
        method: 'POST',
        data,
    });
    return response.data;
};

const balanceTransferServices = {
  getCardBalanceList,
  addBalanceTransfers,
};

export default balanceTransferServices;
